export default __webpack_public_path__ + "static/media/gear.1f86acb5.svg";